import * as React from 'react'
import { Typography } from "@mui/material";
import {  PlanetType } from "../types";

function PlanetImageInst(planetType) {
    let id = 'icon-planet-unknown'
    if (planetType == PlanetType.Jovian) id = 'icon-planet-jovian';
    if (planetType == PlanetType.Neptunian) id = 'icon-planet-neptunian';
    if (planetType == PlanetType.SuperEarth) id = 'icon-planet-superearth';
    if (planetType == PlanetType.Terrestrial) id = 'icon-planet-terrestrial';
    return document.getElementById(id) as HTMLImageElement
}

export function drawPlanetsToSummaryPanel(planets: PlanetType[], internalSize: number) {
    const canvas = document.getElementById('star-system-summary-panel-canvas') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext("2d")!;
    canvas.width = (internalSize * planets.length) + (SPACING_INTERNAL * (planets.length - 1))
    canvas.height = internalSize
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < planets.length; i++) {
        const src_img = PlanetImageInst(planets[i])
        ctx.drawImage(src_img, i * (internalSize + SPACING_INTERNAL), 0)
    }
}

const CANVAS_INTERNAL_SIZE = 512
const SPACING_INTERNAL = 20

interface StarSystemSummaryPanelProps {
    planets: PlanetType[],
    style: React.CSSProperties | undefined,
    size: number,
    hostname: string,
    alpha: number
}

export function StarSystemSummaryPanel({ planets, size, style, hostname, alpha }: StarSystemSummaryPanelProps) {
    React.useEffect(() => {
        drawPlanetsToSummaryPanel(planets, CANVAS_INTERNAL_SIZE)
    }, [planets])

    const spacing_external = size * SPACING_INTERNAL / CANVAS_INTERNAL_SIZE
    const alphaHex = Math.round(alpha * 255).toString(16).padStart(2, '0');
    const color = `#FFFFFF${alphaHex}`;

    return (
        <div id='star-system-summary-panel'
            style={{
                position: 'absolute',
                left: -1000,
                top: -1000,
                pointerEvents: 'none',
                translate: `20px 20px`,
                textAlign: 'left',
                ...style,
            }}>
            <Typography color={color} fontSize={18} style={{ textIndent: 10 }}>{hostname}</Typography>
            <canvas id='star-system-summary-panel-canvas'
                style={{
                    width: (size * planets.length) + (spacing_external * (planets.length - 1)),
                    height: size
                }} />
        </div >
    )
}